"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateZip = void 0;
function validateZip(zip) {
    if (typeof zip !== 'string')
        return false;
    return /(?:^[0-9]{9}$)|(?:^[0-9]{5}(?:-[0-9]{4})?)$/.test(zip);
}
exports.validateZip = validateZip;
//# sourceMappingURL=validateZip.js.map